import { render, staticRenderFns } from "./AlertBeforeDelete.vue?vue&type=template&id=601be1a4&"
import script from "./AlertBeforeDelete.vue?vue&type=script&lang=js&"
export * from "./AlertBeforeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports